import { notifyError, notifySuccess } from "../../helpers/helpers";
import { registerSW, subscribe } from "../../helpers/serviceWorkerHelper";
import { Auth, auction } from "../config/urlConfig";

async function registerAndSubscribe() {
  try {
    const serviceWorker = await registerSW();
    await subscribe(serviceWorker);
  } catch (error) { }
}

export const registerPhoneNumber =
  (phoneNumber, navigate) => async (dispatch) => {
    dispatch({ type: "SHOW_LOADING" });
    try {
      const { data } = await Auth.post(`/account/create/step-1`, phoneNumber);
      dispatch({
        type: "REGISTER_PHONE_NUMBER",
        payload: data,
        phoneNumber: phoneNumber?.phoneNumber,
      });

      dispatch({ type: "HIDE_LOADING" });
      navigate("/otp-verification/step-2");
    } catch (error) {
      dispatch({ type: "HIDE_LOADING" });
      notifyError(
        error.response ? error.response?.data : error.message,
        error.response?.status,
      );
    }
  };

export const otpVerification =
  (phoneNumber, OTP, sessionId, navigate) => async (dispatch) => {
    dispatch({ type: "SHOW_LOADING" });
    try {
      const { data } = await Auth.post(`/account/create/step-2`, {
        phoneNumber: phoneNumber,
        OTP: OTP,
        sessionId: sessionId?.session,
      });
      if (data?.session) {
        dispatch({
          type: "OTP_VERIFICATION",
          payload: data,
        });
        dispatch({ type: "HIDE_LOADING" });
        navigate("/create-Account/step-3");
      } else {
        localStorage.setItem('CCXT', data.token)
        dispatch(authenticateWithAuction(data.token, navigate));
      }
    } catch (error) {
      dispatch({ type: "HIDE_LOADING" });
      notifyError(
        error.response ? error.response?.data : error.message,
        error.response?.status,
      );
    }
  };

export const userDetailsToLogin =
  (sessionId, name, emailId, password) => async (dispatch) => {
    const navigate = ''
    dispatch({ type: "SHOW_LOADING" });
    try {
      const { data } = await Auth.post(`/account/create/step-3`, {
        sessionId: sessionId,
        name: name,
        email: emailId,
        password: password,
      });
      dispatch({ type: "HIDE_LOADING" });
      localStorage.setItem('CCXT', data.token)

      dispatch(authenticateWithAuction(data.token, navigate));
    } catch (error) {
      dispatch({ type: "HIDE_LOADING" });
      notifyError(
        error.response ? error.response?.data : error.message,
        error.response?.status,
      );
    }
  };

export const loginUser = (medium, password) => async (dispatch) => {
  dispatch({ type: "LOGGING_IN" });
  try {
    const { data: token } = await Auth.post("/account/login/step-1", {
      medium: medium,
      password: password,
    });
    try {
      const config = { headers: { "X-Authentication-Token": token } };
      const { data } = await auction.post("/authenticate", {}, config);
      auction.defaults.headers.common["X-Authentication-Token"] = data;
      dispatch({ type: "HIDE_LOADING" });
      dispatch({ type: "LOGGED" });
      localStorage.setItem("auction-client", data);
      window.location.href = "/";
    } catch (error) {
      notifyError(
        error.response ? error.response?.data : error.message,
        error.response?.status,
      );
      dispatch({ type: "CANNOT_LOGIN" });
    }
  } catch (error) {
    dispatch({ type: "CANNOT_LOGIN" });
    notifyError(
      error.response ? error.response?.data : error.message,
      error.response?.status,
    );
  }
};

export const getMyOrganization = () => async (dispatch) => {
  dispatch({ type: "GET_MY_ORGANIZATION" });
  try {
    const { data } = await auction.get("/profile/read/organization");
    dispatch(
      updateUserTypeAction(
        data?.role?.name,
        data?.accountSetUp === "completed",
        data?.verified,
      )
    );
    dispatch({ type: "MY_ORGANIZATION", payload: data });
  } catch (error) {
    dispatch({ type: "GET_MY_ORGANIZATION_FAILED" });
    notifyError(
      error.response ? error.response?.data : error.message,
      error.response?.status,
    );
  }
};

export const getUserProfile = () => async (dispatch) => {
  dispatch({ type: "GET_USER_PROFILE" });
  try {
    await auction.get("/profile/read").then((res) => {
      dispatch({ type: "GET_USER_PROFILE_SUCCESS", payload: res.data });
    });
  } catch (error) {
    dispatch({ type: "GET_USER_PROFILE_FAILED" });
    notifyError(
      error.response ? error.response?.data : error.message,
      error.response?.status
    );
  }
};

export const postAccountType =
  (types, organizationName, navigate) => async (dispatch) => {
    dispatch({ type: "SHOW_ACCOUNT_TYPE_LODDING" });
    try {
      await auction
        .put(`/profile/update/organization-type`, {
          accountType: types,
          organizationName: organizationName,
        })
        .then(() => {
          if (types === "industry") {
            dispatch(getMyOrganization());
            window.location.href = "/";
          } else {
            navigate("/select-scrap");
          }
        });

      dispatch({ type: "GET_ACCOUNT_TYPE" });
    } catch (error) {
      dispatch({ type: "HIDE_ACCOUNT_TYPE_LODDED" });
      notifyError(
        error.response ? error.response?.data : error.message,
        error.response?.status,
      );
    }
  };

export const updateUserTypeAction =
  (userType, accountStatus, VerifyGstAccount,) => async (dispatch) => {
    dispatch({ type: "UPDATE_USER_TYPE" });
    try {
      dispatch({ type: "UPDATE_USER_TYPE_SUCCESS", userType: userType });
      dispatch({
        type: "UPDATE_ACCOUNT_STATUS",
        accountStatus: accountStatus,
        VerifyGstAccount: VerifyGstAccount,
      });
    } catch (error) {
      dispatch({ type: "UPDATE_USER_TYPE_FAILED" });
    }
  };

export const authenticateWithAuction = (token, navigate) => async (dispatch) => {
  try {
    const config = { headers: { "X-Authentication-Token": token } };
    const { data } = await auction.post("/authenticate", {}, config);

    if (data.name) {
      dispatch({ type: "HIDE_LOADING" });

      navigate("/create-Account/complete-account-setup")

    } else {
      dispatch({ type: "HIDE_LOADING" });
      auction.defaults.headers.common["X-Authentication-Token"] = data;
      dispatch({ type: "HIDE_LOADING" });
      localStorage.setItem("auction-client", data);
      localStorage.setItem("callRegisterAndSubscribe", "true");
      window.location.href = "/";
    }

  } catch (error) {
    notifyError(
      error.response ? error.response?.data : error.message,
      error.response?.status,
    );
    dispatch({ type: "HIDE_LOADING" });
  }
};

export const logOut = () => async (dispatch) => {
  dispatch({ type: "SHOW_LOTOUT_LOADING" });
  try {
    await auction.put(`/authenticate/logout`);
    dispatch({ type: "SHOW_LOGOUT_SUCCESS" });
    localStorage.removeItem("auction-client");
    window.location.href = "/login";
  } catch (error) {
    dispatch({ type: "SHOW_LOGOUT_FAILED" });
    localStorage.removeItem("auction-client");
    window.location.href = "/login";

  }
};

export const completeAccountSetupStep1 = (email) => async (dispatch) => {
  dispatch({ type: "SHOW_LOADING" });
  const token = localStorage.getItem("CCXT");
  const config = { headers: { "X-Authentication-Token": token } };

  try {
    const { data } = await auction.post("/authenticate/complete-account-setup-step-1", {
      email: email
    }, config);
    notifySuccess(data)
    dispatch({ type: "HIDE_LOADING" });

  } catch (error) {
    dispatch({ type: "HIDE_LOADING" });

    notifyError(
      error.response ? error.response?.data : error.message,
      error.response?.status,
    );
  }
}

export const completeAccountSetupStep2 = (newPassword, confirmPassword) => async (dispatch) => {
  dispatch({ type: "SHOW_LOADING" });
  const token = localStorage.getItem("CCXT");
  const config = { headers: { "X-Authentication-Token": token } };
  try {
    const { data } = await auction.post("/authenticate/complete-account-setup-step-2", {
      newPassword: newPassword, confirmPassword: confirmPassword
    }, config);
    localStorage.setItem("auction-client", data);
    localStorage.setItem("callRegisterAndSubscribe", "true");
    window.location.href = "/";
    dispatch({ type: "HIDE_LOADING" });

  } catch (error) {
    dispatch({ type: "HIDE_LOADING" });

    notifyError(
      error.response ? error.response?.data : error.message,
      error.response?.status,
    );

  }
}